import B2ChatClient from '@client-sdk';
import {
  updateUserStatus,
  updateUserStatusFailure,
  updateUserStatusFulfill,
  updateUserStatusSuccess,
} from '@reducers/userStatus';
import { ErrorData } from '@types';
import { B2ChatAPI } from '@types-api';
import { call, put, takeLatest } from 'redux-saga/effects';

function* updateUserStatusSaga(action: ReturnType<typeof updateUserStatus>) {
  const { userId, status } = action.payload;
  try {
    const response = (yield call(
      [B2ChatClient.resources.user.actions, 'updateUserStatus'],
      { data: { status }, params: { userId } }
    )) as B2ChatAPI.Response<unknown>;

    if (response.error != null) {
      yield put(updateUserStatusFailure(response.error));
    } else {
      yield put(updateUserStatusSuccess());
    }
  } catch (error) {
    yield put(updateUserStatusFailure(error as ErrorData));
  } finally {
    yield put(updateUserStatusFulfill());
  }
}

function* UserStatusSaga() {
  yield takeLatest(updateUserStatus, updateUserStatusSaga);
}

export default UserStatusSaga;
